import React, { useState, useEffect, useContext, useRef } from "react";
import { ShiftProps } from "../../interfacesProps/ShiftProps";
import { AuthService } from "../../api/AuthService";
import { IndustryModeEnum, getEffectiveRoleName, roleNameEnum, RoutePathConstant } from "../../util/Common";
import { ShiftService } from "../../api/ShiftService";
import { LoadingIndicator } from "../../components/LoadingIndicator";
import { Spacing, FontWeight, FontSize, Font } from "../../theme/Theme";
import { RBCardView } from "../../components/RBCardView";
import moment from "moment-timezone";
import {
  Button,
  IconButton,
  Menu,
  MenuItem,
  Tabs,
  Typography,
  Paper,
  ListItemText,
} from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import { ColumnStyle } from "../../theme/ComponentTheme";
import {
  detailKmAllowanceIcon,
  detailAccomodationAllowanceIcon,
} from "../../util/Icons";
import { useHistory } from "react-router";
import { RBContext } from '../../components/RBContext';
import { RBAppbar } from "../../components/RBAppbar";
import TuneIcon from "@material-ui/icons/Tune";
import FilterListIcon from "@material-ui/icons/FilterList";
import CheckIcon from "@material-ui/icons/Check";
import { RBModal } from "../../components/RBModal";
import FormatListBulletted from "@material-ui/icons/FormatListBulleted";
import SwapHorizIcon from "@material-ui/icons/SwapHoriz";
import { paymentTypeEnum } from "../../util/Enumeration";
import ShiftRatedRow from "../../components/ShiftRatedRow";
import { getShiftRatingValue, isShiftRatingWindowOpen } from "../../util/shiftRating";
import { Colors } from "../../theme/Theme";
import ShiftPaymentModal from "../../components/ShiftPaymentModal";
import { RBAlert } from "../../components/RBAlert";
import { AlertInfoProps } from "../../interfacesProps/AlertInfoProps";
import { RBButton, RBButtonType } from "../../components/RBButton";
import NotificationService, {
  NotificationServiceTopic,
} from "../../api/NotificationService";
import { ShiftRelatedConstants } from "../../util/ShiftConstants";
import { getRequestPaymentDisableInfo } from "../../util/RequestPaymentReminder";
import { dateOnlyToUtcIso } from "../../util/DatetimeUtils";
import { useStripePaymentRefresh } from "../../util/useStripePaymentRefresh";

import {
  getPaymentInfoAvailability,
} from "../../util/PaymentInfoAvailability";
import { AccountInfoContext } from "../../components/AccountInfoContext";

const useStyles = makeStyles({
  button: {
    borderRadius: 8,
    borderWidth: 1,
    backgroundColor: "#FFF",
    "&:hover": {
      backgroundColor: "#CDCDCD",
    },
  },
});

const styles = {
  container: {
    flex: 1,
  },
  itemContainer: {
    paddingHorizontal: 16,
    paddingVertical: 8,
  },
  itemColumns: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
  },
  itemLeft: {
    flex: 1,
    marginRight: 5,
  },
  itemsRight: {
    flexDirection: "column",
    marginLeft: 5,
  },
};
const lastColumnWidth = 90;

export const PayrollPage = () => {
  const classes = useStyles();
  const {
    primaryColor,
    secondaryColor,
    industryMode,
    updateprimaryColor,
    updateSecondaryColor,
    updateContactEmail,
    updateContactPhone,
    updateMode,
  } = useContext(RBContext);
  const [shifts, setShifts] = useState<ShiftProps[]>([]);
  const [roleName] = useState<string>(AuthService.getRoleName());
  const [effectiveRoleName, setEffectiveRoleName] = useState<string>(roleName);
  const isOwnerLike = effectiveRoleName === roleNameEnum.owner;
  const [isPageLoading, setIsPageLoading] = useState(true);
  const [monthlyValue, setMonthlyValue] = useState(0);
  const [totalValue, setTotalValue] = useState(0);
  const history = useHistory();
  const anchorTuneRef = React.useRef<HTMLButtonElement>(null);
  const anchorFilterRef = React.useRef<HTMLButtonElement>(null);
  const [openTuneSetting, setOpenTuneSetting] = useState(false);
  const [showAllShifts, setShowAllShifts] = useState(false);
  const [viewOption, setViewOption] = useState('List');

  type PaymentFilterOption = "all" | "paid" | "unpaid" | "rate-shift";
  const [paymentFilter, setPaymentFilter] = useState<PaymentFilterOption>(
    "all"
  );
  const [paymentFilterAnchorEl, setPaymentFilterAnchorEl] = useState<
    null | HTMLElement
  >(null);

  const [account, setAccount] = useState(null);
  const didMountRef = useRef(false);

  const [isAlertShowing, setIsAlertShowing] = useState(false);
  const [alertInfo, setAlertInfo] = useState<AlertInfoProps>({});

  const [paymentModalVisible, setPaymentModalVisible] = useState(false);
  const [paymentShift, setPaymentShift] = useState<ShiftProps | null>(null);
  const [stripeRefreshTrigger, setStripeRefreshTrigger] = useState(0);

  const { accountInformation  } = useContext(AccountInfoContext);

  // Hook for auto-refresh after Stripe payment
  const { startStripePaymentWatch } = useStripePaymentRefresh({
    shiftId: paymentShift?.id as string,
    onRefresh: () => setStripeRefreshTrigger(prev => prev + 1),
  });

  const handleRequestPayment = (shift: ShiftProps) => {
    const disableInfo = getRequestPaymentDisableInfo(shift);
    if (disableInfo.disabled) {
      showOkAlert("Request Payment", disableInfo.reason || "You cannot request payment right now.");
      return;
    }

    const locationName =
      shift?.pharmacy?.displayName ||
      shift?.pharmacy?.name ||
      (shift as any)?.location ||
      "Location";

    setAlertInfo({
      title: "Request Payment",
      message: "Are you sure you want to send the request payment message?",
      buttons: [
        <RBButton
          key={"confirmPayrollRequestPayment"}
          onClick={async () => {
            try {
              setIsAlertShowing(false);
              if (!shift?.id) {
                throw new Error("No shift selected for payment request");
              }
              await ShiftService.requestShiftPayment(shift.id as string);
              setAlertInfo({
                title: "Request Payment",
                message: `Your request has been emailed to ${locationName}`,
                buttons: [
                  <RBButton
                    key={"okPayrollRequestPayment"}
                    onClick={() => setIsAlertShowing(false)}
                    buttonBackgroundColor={secondaryColor}
                    text="Ok"
                  />,
                ],
              });
              setIsAlertShowing(true);
              await fetchData();
            } catch (err) {
              const e: any = err;
              showOkAlert(
                "Error",
                e?.response?.data?.message ||
                e?.response?.data?.error ||
                e?.response?.data ||
                e?.message
              );
            }
          }}
          buttonBackgroundColor={primaryColor}
          text="Yes"
        />,
        <RBButton
          key={"cancelPayrollRequestPayment"}
          buttonType={RBButtonType.cancel}
          onClick={() => setIsAlertShowing(false)}
          text="Cancel"
        />,
      ],
    });
    setIsAlertShowing(true);
  };

  const accountNetworkDoesNotPay =
    (account as any)?.networks?.some(
      (n: any) => n?.paymentConfig?.networkPays === false
    ) === true;

  const canShowPaymentFilter =
    (isOwnerLike || roleName === roleNameEnum.pharmacist)      
      const canShowPaidUnpaidOptions = accountNetworkDoesNotPay;

  const openPaymentFilterMenu = (event: React.MouseEvent<HTMLElement>) => {
    setPaymentFilterAnchorEl(event.currentTarget);
  };

  const closePaymentFilterMenu = () => {
    setPaymentFilterAnchorEl(null);
  };

  const selectPaymentFilter = (value: PaymentFilterOption) => {
    setPaymentFilter(value);
    closePaymentFilterMenu();
  };

  const openPaymentModal = (shift: ShiftProps) => {
    setPaymentShift(shift);
    setPaymentModalVisible(true);
  };

  const closePaymentModal = () => {
    setPaymentModalVisible(false);
    setPaymentShift(null);
  };

  const showOkAlert = (title: string, message: any) => {
    const msg =
      message?.message ||
      message?.error ||
      (typeof message === "string" ? message : JSON.stringify(message, null, 2));
    setAlertInfo({
      title,
      message: msg,
      buttons: [
        <RBButton
          key={"okPayroll"}
          onClick={() => setIsAlertShowing(false)}
          buttonBackgroundColor={secondaryColor}
          text="Ok"
        />,
      ],
    });
    setIsAlertShowing(true);
  };

  const handleCreatePayment = async (payload: any) => {
    try {
      if (!paymentShift || !paymentShift.id) {
        throw new Error("No shift selected for payment");
      }
      const selectedMethod = String(payload?.paymentMethod || "").trim().toLowerCase();

      if (selectedMethod === "stripe") {
        const response = await ShiftService.createShiftStripePaymentLink(paymentShift.id as string);
        const paymentLink = response?.paymentLink || response?.stripePaymentLink || response?.url;
        if (!paymentLink) {
          throw new Error("Stripe payment link was not returned.");
        }
        window.open(paymentLink, "_blank", "noopener,noreferrer");
        // Start watching for payment completion (auto-refresh on focus/polling)
        startStripePaymentWatch();
        // Close modal and return early for Stripe payments
        setPaymentModalVisible(false);
        return;
      }

      const body = {
        shiftId: paymentShift.id,
        status: "paid",
        paymentDate: dateOnlyToUtcIso(payload.paymentDate),
        paymentMethod: payload.paymentMethod,
        paymentMethodOther: payload.paymentOtherDescription || "",
        paymentReference: payload.paymentReference || "",
      };
      await ShiftService.createShiftPayment(body);
      NotificationService.publish(
        NotificationServiceTopic.ShiftChanged,
        paymentShift.id
      );
      showOkAlert("Success", "Shift payment details saved.");
      await fetchData();
    } catch (err) {
      const e: any = err;
      showOkAlert("Error", e?.response ? e.response.data : e?.message);
    }
  };

  const handleUpdatePayment = async (payload: any) => {
    try {
      if (!paymentShift || !paymentShift.id) {
        throw new Error("No shift selected for payment update");
      }
      const selectedMethod = String(payload?.paymentMethod || "").trim().toLowerCase();

      if (selectedMethod === "stripe") {
        const response = await ShiftService.createShiftStripePaymentLink(paymentShift.id as string);
        const paymentLink = response?.paymentLink || response?.stripePaymentLink || response?.url;
        if (!paymentLink) {
          throw new Error("Stripe payment link was not returned.");
        }
        window.open(paymentLink, "_blank", "noopener,noreferrer");
        // Start watching for payment completion (auto-refresh on focus/polling)
        startStripePaymentWatch();
        // Close modal and return early for Stripe payments
        setPaymentModalVisible(false);
        return;
      }

      const body = {
        shiftId: paymentShift.id,
        status: "paid",
        paymentDate: dateOnlyToUtcIso(payload.paymentDate),
        paymentMethod: payload.paymentMethod,
        paymentMethodOther: payload.paymentOtherDescription || "",
        paymentReference: payload.paymentReference || "",
      };
      await ShiftService.updateShiftPayment(paymentShift.id as string, body);
      NotificationService.publish(
        NotificationServiceTopic.ShiftChanged,
        paymentShift.id
      );
      showOkAlert("Success", "Shift payment details updated.");
      await fetchData();
    } catch (err) {
      const e: any = err;
      showOkAlert("Error", e?.response ? e.response.data : e?.message);
    }
  };


  const fetchData = async () => {
    setIsPageLoading(true);

    const shiftPaid =
      paymentFilter === "paid"
        ? true
        : paymentFilter === "unpaid"
          ? false
          : undefined;

    // Ensure
    if (!accountInformation) return;

    const userData = accountInformation;
    if (userData?.networks?.[0]) {
      await updateprimaryColor(userData.networks[0].brand?.primaryColor);
      await updateSecondaryColor(userData.networks[0].brand?.secondaryColor);
      await updateContactEmail(userData.networks[0].contactEmail);
      await updateContactPhone(userData.networks[0].contactPhone);
    }
    if (userData?.owner?.defaultPharmacyId && userData?.pharmacies?.length) {
      const activePharmacy = userData.pharmacies.find(
        (pharmacy: any) => pharmacy.id === userData.owner.defaultPharmacyId
      );
      if (activePharmacy?.industryMode) {
        await updateMode(activePharmacy.industryMode);
      }
    }

    const nextEffectiveRoleName = getEffectiveRoleName(userData, roleName);
    setEffectiveRoleName(nextEffectiveRoleName);
    setAccount(userData);
    if (nextEffectiveRoleName === roleNameEnum.owner) {
      const isRegionalManager = roleName === roleNameEnum.regionalmanager;
      const selectedPharmacyId =
        localStorage.getItem("regionalManagerSelectedLocationId") ||
        userData?.owner?.defaultPharmacyId;
      const selectedOwnerId =
        localStorage.getItem("regionalManagerSelectedUserId") ||
        userData?.pharmacies?.find((item: any) => item.id === selectedPharmacyId)
          ?.owner?.id ||
        userData?.owner?.userId ||
        userData?.id;

      const result = await ShiftService.getShiftListForOwner({
        state: "processed",
        "sort[]": "-startTime",
        showAllShifts,
        limit: 10000,
        ...(isRegionalManager
          ? {
            ownerId: selectedOwnerId,
            pharmacyId: selectedPharmacyId,
          }
          : {}),
        ...(typeof shiftPaid === "boolean" ? { shiftPaid } : {}),
      });
      console.log("owner payroll result ", result.data);
      setShifts(result.data);
      setShowAllShifts(
        localStorage.getItem("showAllShifts")
          ? localStorage.getItem("showAllShifts") === "Yes"
          : false
      );
      
    } else if (nextEffectiveRoleName === roleNameEnum.pharmacist) {
      const result = await ShiftService.getShiftListForWorker({
        state: "acknowledged",
        "sort[]": "-startTime",
        limit: 10000,
        ...(typeof shiftPaid === "boolean" ? { shiftPaid } : {}),
      });
      console.log("worker payroll result ", result.data);
      setShifts(result.data);
    }
    setIsPageLoading(false);
  };

  // Initial fetch on mount
  useEffect(() => {
    console.log("PayrollPage  shifts", shifts);

    fetchData();
    setViewOption('List');

    return () => {
      console.log("PayrollPage clean up");
    };
  }, []);

  // Refresh when Stripe payment is completed (user returns from Stripe)
  useEffect(() => {
    if (stripeRefreshTrigger > 0) {
      console.log("PayrollPage: Stripe payment refresh triggered");
      fetchData();
    }
  }, [stripeRefreshTrigger]);

  useEffect(() => {
    if (didMountRef.current) {
      // const saveShowAllShifts = async () => {
      //    localStorage.setItem("showAllShifts", showAllShifts ? "Yes" : "No");
      // };
      // saveShowAllShifts();
      console.log("showAllShifts changed for shift list", showAllShifts);
      localStorage.setItem("showAllShifts", showAllShifts ? "Yes" : "No");
      fetchData();
    } else {
      didMountRef.current = true;
    }
  }, [showAllShifts, viewOption, paymentFilter]);

  useEffect(() => {
    if (
      !canShowPaidUnpaidOptions &&
      (paymentFilter === "paid" || paymentFilter === "unpaid")
    ) {
      setPaymentFilter("all");
    }
  }, [canShowPaidUnpaidOptions, paymentFilter]);
  const setMonthlyAndTotalValue = async () => {
    if (effectiveRoleName === roleNameEnum.owner) {
      const { monthlyPaid, totalPaid } = ShiftService.getPayoutsForShifts(
        shifts
      );
      setMonthlyValue(monthlyPaid);
      setTotalValue(totalPaid);
    } else if (effectiveRoleName === roleNameEnum.pharmacist) {
      const userData = accountInformation;
      if (userData?.pharmacist?.earnings) {
        setMonthlyValue(userData.pharmacist.earnings.monthly / 100);
        setTotalValue(userData.pharmacist.earnings.overall / 100);
      }
    }
  };
  useEffect(() => {
    setMonthlyAndTotalValue();
  }, [shifts]);
  useEffect(() => {
    const handleRegionalManagerLocationChange = async () => {
      await fetchData();
    };

    window.addEventListener(
      "regional-manager-location-changed",
      handleRegionalManagerLocationChange
    );

    return () => {
      window.removeEventListener(
        "regional-manager-location-changed",
        handleRegionalManagerLocationChange
      );
    };
  }, []);
  // Helper function to refetch data based on the current account context.
  useEffect(() => {
    if (accountInformation && Object.keys(accountInformation).length > 0) {
      fetchData();
    }
  }, [accountInformation]);

  console.log("user data in payroll page", account);
  console.log("shifts data in payroll page", shifts);
  const renderAllowance = (shift: ShiftProps) => {
    const kmAllowanceAvailable = shift.kmAllowance > 0;
    const accommodationAllowanceAvailable = shift.accomodationAllowance > 0;
    return (
      <div
        style={{
          display: "flex",
          flexDirection: "row",
          justifyContent: "flex-start",
          alignItems: "center",
          // marginTop: spacing.small,
        }}
      >
        {kmAllowanceAvailable && (
          <div style={{ backgroundColor: "white", marginRight: 4 }}>
            {detailKmAllowanceIcon(primaryColor)}
          </div>
        )}
        {accommodationAllowanceAvailable && (
          <div style={{ backgroundColor: "white" }}>
            {detailAccomodationAllowanceIcon(primaryColor)}
          </div>
        )}
      </div>
    );
  };
  // const PaymentStatus = (isStripeInvoicePaid:any ) => {
  //   //isStripeInvoicePaid = false;
  //   console.log("isStripeInvoicePaid",isStripeInvoicePaid)
  //   const boxColor = isStripeInvoicePaid ? '#C8E6C9' : '#FFCDD2';
  //   const textColor = isStripeInvoicePaid ? '#00695C' : '#D32F2F';
  //   const iconName = isStripeInvoicePaid ? 'check' : 'times';

  //   return (
  //     <Typography style={{ backgroundColor: boxColor,width: lastColumnWidth }}>
  //       {/* <Icon name={iconName} size={10} color={textColor} style={styles.icon} /> */}
  //     <Typography style={{ color: textColor,paddingLeft:3,paddingRight:3,paddingTop:2,paddingBottom:2, textAlign:'center' ,width: lastColumnWidth }}>
  //       {isStripeInvoicePaid ? 'Succeeded' : 'Failed'}
  //     </Typography>

  //   </Typography>
  //   );
  // };
  const renderPayrollItemForOwner = (item: ShiftProps, account: any) => {
    // const actualStartTime = moment(item.actualStartTime).tz(item.shiftTimeZone);
    // const actualEndTime = moment(item.actualEndTime).tz(item.shiftTimeZone);
    const officialStartTime = moment(item.officialStartTime).tz(item.shiftTimeZone);
    const officialEndTime = moment(item.officialEndTime).tz(item.shiftTimeZone);

    const actualDateString = officialStartTime.format("ddd, MMM Do YYYY");
    const shiftNumber = item.shiftNumber || 'N/A';
    const actualHoursDisplay = ShiftService.getShiftOfficialLengthDisplay(item);
    const shiftNetworkPaid = item.networkPaid ? item.networkPaid : item.pharmacy.networkPaid;
    const isPaid = !!item?.paymentData;
    const isNetworkPaid = !!shiftNetworkPaid;

    const paymentInfo = getPaymentInfoAvailability(item);
    const paymentInfoNotApplicable = paymentInfo.notApplicable;

    const canShowPaymentActions =
      !!item?.flags?.isCompletionAcknowledged &&
      !item?.flags?.isCancelled &&
      !isPaid &&
      !isNetworkPaid &&
      !paymentInfoNotApplicable;
    let wage = 0;
    let ownerTotalWage = 0;
    const hasActualCommission =
      item.actualCommission !== undefined && item.actualCommission !== null;
    if (hasActualCommission) {
      if (shiftNetworkPaid == true) {
        if (isOwnerLike) {
          ownerTotalWage = (item.wage / 100) + ShiftService.getPlacementFee(item);
          wage = item.wage / 100;
        }
      }
      else {
        ownerTotalWage = ShiftService.getWage(item, account) / 100;
        wage = ShiftService.getWage(item, account) / 100;
      }
    }
    else {
      wage = ShiftService.getWage(item, account) / 100;
    }


    //const wage = ShiftService.getWage(item) / 100;

    let minutesWorked = moment(item.officialEndTime).diff(
      moment(item.officialStartTime),
      'minutes',
    );
    if (hasActualCommission) {
      if (item.disputeResolution === null) {
        if (item.unpaidBreakMinutes) {
          minutesWorked = minutesWorked - item.unpaidBreakMinutes
        }
        if (item.disputeUnpaidBreakMinutes) {
          minutesWorked = minutesWorked - item.disputeUnpaidBreakMinutes
        }
      }
      else {
        if (item.disputeResolution === 'pharmacy') {
          minutesWorked = minutesWorked - item.disputeUnpaidBreakMinutes
        }
        if (item.disputeResolution === 'pharmacist') {
          minutesWorked = minutesWorked - item.unpaidBreakMinutes
        }
      }
    }


    let totalAmount = '';
    const allowanceAvailable =
      item.kmAllowance > 0 || item.accomodationAllowance > 0;
    const kmAllowance = item.kmAllowance ?? 0;
    const distance = Math.round(((item.shiftDistance ?? 0) * 2) / 1000);
    const allowanceAmount = kmAllowance * distance + (item.accomodationAllowance ?? 0);

    if (item.networkPaid) {
      totalAmount = ((item.paidIn + item.paidTax) / 100).toFixed(2);
      if (item.surchargeAmount !== null && item.surchargeAmount > 0) {
        totalAmount = ((item.paidIn + item.paidTax + (item.surchargeAmount * 100)) / 100).toFixed(2);
      }
    }
    else {
      let newWage;
      if (item.flags.isCancelled && item.isCancellationFeeApplied) {
        totalAmount = item.shiftCancellationFee;
      }
      else {
        newWage = hasActualCommission ? ownerTotalWage : wage;
        totalAmount = (newWage * (minutesWorked / 60) + (allowanceAmount / 100)).toFixed(2);
      }
    }

    // const totalAmount = ((item.paidIn + item.paidTax) / 100).toFixed(2);


    const ratingValue = getShiftRatingValue(
      item as any,
      industryMode as any,
      effectiveRoleName
    );
    const hasRatingValue = typeof ratingValue === 'number' && Number.isFinite(ratingValue);
    const canRateShift = isShiftRatingWindowOpen(item as any);
    const shouldShowRatingRow = hasRatingValue || (!item?.flags?.isCancelled && !canRateShift);

    return (
      <div>
        <div style={{ ...ColumnStyle, paddingBottom: 0 }}>
          <Typography style={{ fontWeight: "bold" }}>
            {item.pharmacy.name}
          </Typography>
          {item.flags.isCancelled && item.isCancellationFeeApplied ? (
            <div
              style={{
                color: "red",
                width: lastColumnWidth,
                boxSizing: "border-box",
                paddingLeft: 13,
                paddingRight: 13,
                paddingTop: 2,
                paddingBottom: 2,
                textAlign: "center",
                backgroundColor: "#FFCCCB",
              }}
            >
              Cancelled
            </div>
          ) : !isNetworkPaid && isPaid ? (
            <div
              style={{
                color: "#1B5E20",
                width: lastColumnWidth,
                boxSizing: "border-box",
                paddingLeft: 13,
                paddingRight: 13,
                paddingTop: 2,
                paddingBottom: 2,
                textAlign: "center",
                backgroundColor: "#C8E6C9",
              }}
            >
              Paid
            </div>
          ) : !isNetworkPaid && !isPaid && !paymentInfoNotApplicable ? (
            <div
              style={{
                color: "red",
                width: lastColumnWidth,
                boxSizing: "border-box",
                paddingLeft: 13,
                paddingRight: 13,
                paddingTop: 2,
                paddingBottom: 2,
                textAlign: "center",
                backgroundColor: "#FFCCCB",
              }}
            >
              Unpaid
            </div>
          ) : null}

        </div>
       <div style={{ ...ColumnStyle, paddingBottom: 0 }}>
          <Typography style={styles.itemLeft}>{shiftNumber}</Typography>
          <Typography></Typography>
        </div>

        <div style={{ ...ColumnStyle, paddingBottom: 0 }}>
          <Typography style={styles.itemLeft}>{actualDateString}</Typography>

          <Typography style={{ fontWeight: "bold", width: lastColumnWidth }}>
            ${totalAmount}
          </Typography>
        </div>
        <div style={{ ...ColumnStyle, paddingBottom: 0 }}>
          <Typography style={styles.itemLeft}>
            {officialStartTime.format("hh:mm a")}{' - '}
            {officialEndTime.format("hh:mm a")} ({actualHoursDisplay})
          </Typography>

          <Typography style={{ fontWeight: "bold", width: lastColumnWidth }}>
            ${wage.toFixed(2)}/hr
          </Typography>
        </div>

        <div style={{ ...ColumnStyle, paddingBottom: 0 }}>
          {allowanceAvailable && (
            <Typography style={styles.itemLeft}>Allowance</Typography>
          )}
          {allowanceAvailable && (
            <Typography
              style={{ alignItems: "flex-start", width: lastColumnWidth }}
            >
              {renderAllowance(item)}
            </Typography>
          )}
        </div>

        {item.networkPaid &&
          <div style={{ ...ColumnStyle, paddingBottom: 0 }}>
            <Typography style={styles.itemLeft}>Applicable Taxes</Typography>
            <Typography style={{ fontWeight: "bold", width: lastColumnWidth }}>
              ${(item.paidTax / 100).toFixed(2)}
            </Typography>
          </div>
        }

        {shouldShowRatingRow && (
          <div style={{ ...ColumnStyle, paddingBottom: 0 }}>
            {hasRatingValue ? (
              <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'flex-end' }}>
                <ShiftRatedRow
                  shift={item as any}
                  industryMode={industryMode as any}
                  roleName={effectiveRoleName}
                />
                <Typography style={{ marginLeft: 6, fontWeight: 'bold' }}>
                  {ratingValue!.toFixed(1)}
                </Typography>
              </div>
            ) : (
              !canRateShift && (
                <Typography style={{ color: Colors.darkGrey }}>Not Rated</Typography>
              )
            )}
          </div>
        )}

        <div style={{ ...ColumnStyle, paddingBottom: 0 }}>
          <div
            style={{
              display: 'flex',
              flexDirection: 'row',
              justifyContent: 'space-between',
              alignItems: 'center',
              paddingTop: Spacing.small,
            }}
          >
            <div>
              {canRateShift && !hasRatingValue && (
                <Button
                  variant="outlined"
                  className={classes.button}
                  style={{
                    textTransform: 'none',
                    padding: '6px 10px',
                    borderColor: primaryColor,
                    color: primaryColor,
                  }}
                  onClick={(e) => {
                    e.preventDefault();
                    e.stopPropagation();
                    history.push(RoutePathConstant.ShiftSurvey + (item as any).id);
                  }}
                >
                  Rate Shift
                </Button>
              )}
            </div>
          </div>
          {/* {isPaid && (
          <div style={{ ...ColumnStyle, paddingBottom: 0 }}>
          <Typography style={styles.itemLeft}></Typography>
              <Typography style={{ fontWeight: "bold", color: primaryColor,width: lastColumnWidth }}>
                Paid
              </Typography>

              </div>
            )}
         */}




          {(canShowPaymentActions) && (
            <div
              style={{
                display: "flex",
                justifyContent: "flex-end",
                alignItems: "center",
                gap: 8,
                marginTop: 10,
              }}
            >
              {/* {isPaid && (
              <Typography style={{ fontWeight: "bold", color: secondaryColor }}>
                Paid
              </Typography>
            )} */}
              {canShowPaymentActions && (
                <>
                  <span
                    title={paymentInfoNotApplicable ? paymentInfo.tooltip : undefined}
                    style={{ display: "inline-flex" }}
                  >
                    <Button
                      className={classes.button}
                      variant="outlined"
                      style={{ borderColor: primaryColor, color: primaryColor, textTransform: "none" }}
                      disabled={paymentInfoNotApplicable}
                      onClick={(e) => {
                        e.stopPropagation();
                        if (paymentInfoNotApplicable) return;
                        openPaymentModal(item);
                      }}
                    >
                      {ShiftRelatedConstants.ShiftButtonText.MarkPaid}
                    </Button>
                  </span>
                  {/* <Button
                  className={classes.button}
                  variant="outlined"
                  style={{ borderColor: primaryColor, color: primaryColor, textTransform: "none" }}
                    borderColor: paymentInfoNotApplicable
                      ? "rgb(223, 223, 223)"
                      : primaryColor,
                    color: paymentInfoNotApplicable ? "#808080" : primaryColor,
                    backgroundColor: paymentInfoNotApplicable ? "#f2f2f2" : "#FFF",
                  }}
                >
                  {ShiftRelatedConstants.ShiftButtonText.RequestPayment}
                </Button> */}
                </>
              )}
            </div>
          )}
        </div>
      </div>
    );
  };
  const renderPayrollItemForWorker = (item: ShiftProps, account: any) => {

    const officialStartTime = moment(item.officialStartTime).tz(item.shiftTimeZone);
    const officialEndTime = moment(item.officialEndTime).tz(item.shiftTimeZone);
    const actualDateString = officialStartTime.format("ddd, MMM Do YYYY");
    const shiftNumber = item.shiftNumber || 'N/A';
    const actualHoursDisplay = ShiftService.getShiftActualLengthDisplay(item);
    //const wage = ShiftService.getWage(item) / 100;
    const shiftNetworkPaid = item.networkPaid ? item.networkPaid : item.pharmacy.networkPaid;
    const isPaid = !!item?.paymentData;
    const isNetworkPaid = !!shiftNetworkPaid;

    const paymentInfo = getPaymentInfoAvailability(item);
    const paymentInfoNotApplicable = paymentInfo.notApplicable;

    const canShowPaymentActions =
      !!item?.flags?.isCompletionAcknowledged &&
      !item?.flags?.isCancelled &&
      !isPaid &&
      !isNetworkPaid &&
      !paymentInfoNotApplicable;

    const requestPaymentDisableInfo = getRequestPaymentDisableInfo(item);

    const showPaidBadge = !isNetworkPaid && isPaid;
    const showUnpaidBadge = !isNetworkPaid && !isPaid && !paymentInfoNotApplicable;

    let wage = 0;
    let ownerTotalWage = 0;
    let minutesWorked = moment(item.officialEndTime).diff(
      moment(item.officialStartTime),
      'minutes',
    );

    // Subtract unpaid breaks FIRST, before using minutesWorked in any calculations
    const hasActualCommission =
      item.actualCommission !== undefined && item.actualCommission !== null;
    if (hasActualCommission) {
      if (item.disputeResolution === 'pharmacy') {
        minutesWorked = minutesWorked - item.disputeUnpaidBreakMinutes
      }
      else {
        minutesWorked = minutesWorked - item.unpaidBreakMinutes
      }
    }

    if (hasActualCommission) {
      if (shiftNetworkPaid == true) {
        if (roleName === roleNameEnum.pharmacist) {
          wage = item.wage / 100;
          if (item.associationId) {
            let commissionWage = ShiftService.getPlacementFee(item);
            if (item.commissionType === 'percentage') {
              let workerBenefit = commissionWage * (item.association?.percentageOnCommission / 100);
              // Apply association max commission dollar cap
              if (
                item.association?.associationMaxCommissionDollar !== null &&
                item.association?.associationMaxCommissionDollar !== undefined
              ) {
                const capInCents = Math.round(
                  item.association.associationMaxCommissionDollar * 100,
                );
                workerBenefit = Math.min(workerBenefit * 100, capInCents) / 100;
              }
              //wage = (item.wage / 100) + workerBenefit;
              wage = (item.wage / 100);
            }
            else {
              let workerBenefit = item.actualCommission * (item.association?.percentageOnCommission / 100);
              // Apply association max commission dollar cap
              if (
                item.association?.associationMaxCommissionDollar !== null &&
                item.association?.associationMaxCommissionDollar !== undefined
              ) {
                const capInCents = Math.round(
                  item.association.associationMaxCommissionDollar * 100,
                );
                workerBenefit = Math.min(workerBenefit * 100, capInCents) / 100;
              }
              //wage = (item.wage / 100) + workerBenefit;
              wage = (item.wage / 100);
            }
          }
        }
      }
      else {
        ownerTotalWage = ShiftService.getWage(item, account) / 100;
        wage = ShiftService.getWage(item, account) / 100;
      }
    }
    else {
      wage = ShiftService.getWage(item, account) / 100;
    }

    const allowanceAvailable =
      item.kmAllowance > 0 || item.accomodationAllowance > 0;
    let totalAmount = "";
    const kmAllowance = item.kmAllowance ?? 0;
    const distance = Math.round(((item.shiftDistance ?? 0) * 2) / 1000);
    const allowanceAmount =
      kmAllowance * distance + (item.accomodationAllowance ?? 0);
    let taxForWorker = 0;
    let workerWageAmount = 0;
    let hourlyRate = 0;

    const isPharmacist = !!account.pharmacist;
    if (isPharmacist) {

      if (!hasActualCommission) {
        workerWageAmount = Math.floor(
          ShiftService.getWage(item, account) * (minutesWorked / 60),
        );
      }
      else {
        workerWageAmount = Math.ceil(
          item.wage * (minutesWorked / 60)
        );

        if (roleName === roleNameEnum.pharmacist) {
          if (item.associationId) {
            let commissionWage = Math.ceil(ShiftService.getPlacementFee(item) * 100);
            if (item.commissionType === 'percentage') {
              let workerBenefit = Math.ceil(commissionWage * (item.association?.percentageOnCommission / 100)) / 100;
              if (
                item.association?.associationMaxCommissionDollar !== null &&
                item.association?.associationMaxCommissionDollar !== undefined
              ) {
                const capInCents = Math.round(
                  item.association.associationMaxCommissionDollar * 100,
                );
                workerBenefit = Math.min(workerBenefit * 100, capInCents) / 100;
              }
              workerWageAmount = Math.ceil(item.wage * (minutesWorked / 60)) + workerBenefit * 100;
            }
            else {
              const commissionBase = item.isFixedHourlyRate
                ? (commissionWage / 100)
                : item.actualCommission;

              let workerBenefit =
                commissionBase * (item.association?.percentageOnCommission / 100);

              // Apply association max commission dollar cap
              if (
                item.association?.associationMaxCommissionDollar !== null &&
                item.association?.associationMaxCommissionDollar !== undefined
              ) {
                const capInCents = Math.round(
                  item.association.associationMaxCommissionDollar * 100
                );
                workerBenefit = Math.min(workerBenefit * 100, capInCents) / 100;
              }

              hourlyRate = (item.wage / 100) + workerBenefit;

              workerWageAmount =
                Math.ceil(item.wage * (minutesWorked / 60)) +
                Math.round(workerBenefit * 100);
            }
          }
        }

      }
      const subTotalAmountForWorker = workerWageAmount + allowanceAmount;
      taxForWorker = hasActualCommission ? Math.ceil(
        subTotalAmountForWorker * (item.salesTaxRate / 100)
      ) :
        Math.floor(
          subTotalAmountForWorker * (item.salesTaxRate / 100)
        );

      if (item.networkPaid) {
        totalAmount = (item.paidOut / 100).toFixed(2);
      } else {
        // paidOut has taxes applied, while subTotal does not
        totalAmount = (subTotalAmountForWorker / 100).toFixed(2);
      }

    }

    //totalAmount = (item.paidOut / 100).toFixed(2);
    // const minutesWorked = moment(item.actualEndTime).diff(
    //   moment(item.actualStartTime),
    //   "minutes"
    // );
    // const workerWageAmount = Math.floor(
    //   ShiftService.getWage(item) * (minutesWorked / 60)
    // );

    // const kmAllowance = item.kmAllowance ?? 0;
    // const distance = Math.round(((item.shiftDistance ?? 0) * 2) / 1000);
    // const allowanceAmount =
    //   kmAllowance * distance + item.accomodationAllowance ?? 0;
    // const subTotalAmountForWorker = workerWageAmount + allowanceAmount;
    // taxForWorker = Math.floor(
    //   subTotalAmountForWorker * (item.salesTaxRate / 100)
    // );
    const ratingValue = getShiftRatingValue(
      item as any,
      industryMode as any,
      effectiveRoleName
    );
    const hasRatingValue = typeof ratingValue === 'number' && Number.isFinite(ratingValue);
    const canRateShift = isShiftRatingWindowOpen(item as any);
    const shouldShowRatingRow = hasRatingValue || (!item?.flags?.isCancelled && !canRateShift);

    return (
      <div>

        <div style={{ ...ColumnStyle, paddingBottom: 0 }}>
          <Typography></Typography>
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              alignItems: "flex-end",
              gap: 4,
              width: lastColumnWidth,
            }}
          >
            {showPaidBadge ? (
              <div
                style={{
                  color: "#1B5E20",
                  width: lastColumnWidth,
                  boxSizing: "border-box",
                  paddingLeft: 13,
                  paddingRight: 13,
                  paddingTop: 2,
                  paddingBottom: 2,
                  textAlign: "center",
                  backgroundColor: "#C8E6C9",
                }}
              >
                Paid
              </div>
            ) : showUnpaidBadge ? (
              <div
                style={{
                  color: "red",
                  width: lastColumnWidth,
                  boxSizing: "border-box",
                  paddingLeft: 13,
                  paddingRight: 13,
                  paddingTop: 2,
                  paddingBottom: 2,
                  textAlign: "center",
                  backgroundColor: "#FFCCCB",
                }}
              >
                Unpaid
              </div>
            ) : null}

            {/* <Typography style={{ fontWeight: "bold" }}>${totalAmount}</Typography> */}
          </div>

        </div>
         <div style={{ ...ColumnStyle, paddingBottom: 0 }}>
          <Typography style={styles.itemLeft}>{shiftNumber}</Typography>
          <Typography></Typography>
        </div>
        <div style={{ ...ColumnStyle, paddingBottom: 0 }}>
          <Typography style={styles.itemLeft}>{actualDateString}</Typography>
          <Typography style={{ fontWeight: "bold", width: lastColumnWidth }}>
            ${totalAmount}
          </Typography>
        </div>



        <div style={{ ...ColumnStyle, paddingBottom: 0 }}>
          <Typography style={styles.itemLeft}>
            {officialStartTime.format("hh:mm a")}{' - '}
            {officialEndTime.format("hh:mm a")} ({actualHoursDisplay})
          </Typography>

          <Typography style={{ fontWeight: "bold", width: lastColumnWidth }}>
            ${wage.toFixed(2)}/hr
          </Typography>
        </div>

        <div style={{ ...ColumnStyle, paddingBottom: 0 }}>
          {allowanceAvailable && (
            <Typography style={styles.itemLeft}>Allowance</Typography>
          )}
          {allowanceAvailable && (
            <Typography
              style={{ alignItems: "flex-start", width: lastColumnWidth }}
            >
              {renderAllowance(item)}
            </Typography>
          )}
        </div>

        {item.networkPaid &&
          <div style={{ ...ColumnStyle, paddingBottom: 0 }}>
            <Typography style={styles.itemLeft}>Applicable Taxes</Typography>
            <Typography style={{ fontWeight: "bold", width: lastColumnWidth }}>
              $
              {item.offloadedSalesTax
                ? (taxForWorker / 100).toFixed(2)
                : (0).toFixed(2)}
            </Typography>
          </div>
        }

        <div style={{ ...ColumnStyle, paddingBottom: 0 }}>
          <Typography style={styles.itemLeft} >
            {item.pharmacy.name}
          </Typography>
        </div>

        {shouldShowRatingRow && (
          <div style={{ ...ColumnStyle, paddingBottom: 0 }}>
            {hasRatingValue ? (
              <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'flex-end' }}>
                <ShiftRatedRow
                  shift={item as any}
                  industryMode={industryMode as any}
                  roleName={effectiveRoleName}
                />
                <Typography style={{ marginLeft: 6, fontWeight: 'bold' }}>
                  {ratingValue!.toFixed(1)}
                </Typography>
              </div>
            ) : (
              !canRateShift && (
                <Typography style={{ color: Colors.darkGrey }}>Not Rated</Typography>
              )
            )}
          </div>
        )}
        <div style={{ ...ColumnStyle, paddingBottom: 0 }}>
          <div
            style={{
              display: 'flex',
              flexDirection: 'row',
              justifyContent: 'space-between',
              alignItems: 'center',
              paddingTop: Spacing.small,
            }}
          >
            <div>
              {canRateShift && !hasRatingValue && (
                <Button
                  variant="outlined"
                  className={classes.button}
                  style={{
                    textTransform: 'none',
                    padding: '6px 10px',
                    borderColor: primaryColor,
                    color: primaryColor,
                  }}
                  onClick={(e) => {
                    e.preventDefault();
                    e.stopPropagation();
                    history.push(RoutePathConstant.ShiftSurvey + (item as any).id);
                  }}
                >
                  Rate Shift
                </Button>
              )}
            </div>

          </div>
          {canShowPaymentActions && (
            <div
              style={{
                display: "flex",
                justifyContent: "flex-end",
                alignItems: "center",
                gap: 8,
                marginTop: 10,
              }}
            >
              <span
                title={paymentInfoNotApplicable ? paymentInfo.tooltip : undefined}
                style={{ display: "inline-flex" }}
              >
                <Button
                  className={classes.button}
                  variant="outlined"
                  style={{
                    borderColor: paymentInfoNotApplicable ? "#BDBDBD" : primaryColor,
                    color: paymentInfoNotApplicable ? "#808080" : primaryColor,
                    backgroundColor: paymentInfoNotApplicable ? "#F5F5F5" : "#FFF",
                    textTransform: "none",
                  }}
                  disabled={paymentInfoNotApplicable}
                  onClick={(e) => {
                    e.stopPropagation();
                    if (paymentInfoNotApplicable) return;
                    openPaymentModal(item);
                  }}
                >
                  {ShiftRelatedConstants.ShiftButtonText.MarkPaid}
                </Button>
              </span>

              <span
                style={{ display: "inline-flex" }}
                onClick={(e) => {
                  e.stopPropagation();
                  if (paymentInfoNotApplicable) {
                    showOkAlert(
                      "Request Payment",
                      paymentInfo.tooltip || "Request Payment is not available yet."
                    );
                    return;
                  }
                  if (requestPaymentDisableInfo.disabled) {
                    showOkAlert(
                      "Request Payment",
                      requestPaymentDisableInfo.reason ||
                      "You cannot request payment right now."
                    );
                  }
                }}
              >
                <Button
                  className={classes.button}
                  variant="outlined"
                  style={{
                    borderColor:
                      paymentInfoNotApplicable || requestPaymentDisableInfo.disabled
                        ? "rgb(223, 223, 223)"
                        : primaryColor,
                    color:
                      paymentInfoNotApplicable || requestPaymentDisableInfo.disabled
                        ? "#808080"
                        : primaryColor,
                    backgroundColor:
                      paymentInfoNotApplicable || requestPaymentDisableInfo.disabled
                        ? "#f2f2f2"
                        : "#FFF",
                    textTransform: "none",
                  }}
                  disabled={paymentInfoNotApplicable || requestPaymentDisableInfo.disabled}
                  onClick={(e) => {
                    e.stopPropagation();
                    if (paymentInfoNotApplicable || requestPaymentDisableInfo.disabled) {
                      return;
                    }
                    handleRequestPayment(item);
                  }}
                >
                  {ShiftRelatedConstants.ShiftButtonText.RequestPayment}
                </Button>
              </span>
            </div>
          )}
        </div>
      </div>
    );
  };
  const renderPayrollItem = (shift: ShiftProps) => {
    const { isCompletionAcknowledged, isCancelled, } = shift.flags;
    const { shiftCancellationFee, isCancellationFeeApplied } = shift;

    return (
      isOwnerLike
        ? (((isCompletionAcknowledged && !isCancelled) ||
          (isCancelled && isCancellationFeeApplied && shiftCancellationFee > 0)) ?
          <RBCardView
            key={shift.id}
            marginHorizontal={Spacing.large}
            marginVertical={Spacing.medium}
            paddingHorizontal={Spacing.large}
            paddingVertical={Spacing.medium}
            clickable={true}
            onClick={() =>
              history.push(`${RoutePathConstant.ShiftDetail}${shift.id}`)
            }
          >
            {renderPayrollItemForOwner(shift, account)}
          </RBCardView>
          : null)
        : <RBCardView
          key={shift.id}
          marginHorizontal={Spacing.large}
          marginVertical={Spacing.medium}
          paddingHorizontal={Spacing.large}
          paddingVertical={Spacing.medium}
          clickable={true}
          onClick={() =>
            history.push(`${RoutePathConstant.ShiftDetail}${shift.id}`)
          }
        >
          {renderPayrollItemForWorker(shift, account)}
        </RBCardView>

      // {roleName === roleNameEnum.owner
      // ?  (((isCompletionAcknowledged && !isCancelled) || 
      // (isCancelled && isCancellationFeeApplied && shiftCancellationFee > 0)) ? renderPayrollItemForOwner(shift,account) : null )
      // : renderPayrollItemForWorker(shift,account)}
      // </RBCardView>
    )
  };

  const renderPayrollHeader = () => {
    if (isOwnerLike) {
      return (
        <div>
          <div style={ColumnStyle}>
            <Typography
              style={{ fontWeight: "bold", fontSize: Font.largest }}
            >
              This Month (total)
            </Typography>
            <Typography
              style={{
                fontWeight: "bold",
                fontSize: Font.largest,
                marginLeft: 4,
              }}
            >
              ${monthlyValue.toFixed(2)}
            </Typography>
          </div>
          <div style={ColumnStyle}>
            <Typography
              style={{ fontWeight: "bold", fontSize: Font.largest }}
            >
              Cummulative (total)
            </Typography>
            <Typography
              style={{
                fontWeight: "bold",
                fontSize: Font.largest,
                marginLeft: 4,
              }}
            >
              ${totalValue.toFixed(2)}
            </Typography>
          </div>
        </div>
      );
    } else if (roleName === roleNameEnum.pharmacist) {
      return (
        <div>
          <div style={ColumnStyle}>
            <Typography
              style={{ fontWeight: "bold", fontSize: Font.largest }}
            >
              This Month (total)
            </Typography>
            <Typography
              style={{
                fontWeight: "bold",
                fontSize: Font.largest,
                marginLeft: 4,
              }}
            >
              ${monthlyValue.toFixed(2)}
            </Typography>
          </div>
          <div style={ColumnStyle}>
            <Typography
              style={{ fontWeight: "bold", fontSize: Font.largest }}
            >
              Cummulative (total)
            </Typography>
            <Typography
              style={{
                fontWeight: "bold",
                fontSize: Font.largest,
                marginLeft: 4,
              }}
            >
              ${totalValue.toFixed(2)}
            </Typography>
          </div>
        </div>
      );
    }
  };
  const renderAppBar = () => {
    // const pharmacyName = AuthService.getOwnerAccountInfo();
    // console.log('ownerAccountInfo', pharmacy)
    return (
      <>
        <RBAppbar
          searchable={false}
          barName={'Financials'}
          barChildren={
            <>
              {canShowPaymentFilter && (
                <>
                  <IconButton
                    style={{ color: primaryColor }}
                    onClick={openPaymentFilterMenu}
                    ref={anchorFilterRef}
                  >
                    <FilterListIcon />
                  </IconButton>

                  <Menu
                    anchorEl={paymentFilterAnchorEl}
                    keepMounted
                    open={Boolean(paymentFilterAnchorEl)}
                    onClose={closePaymentFilterMenu}
                    getContentAnchorEl={null}
                    anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
                    transformOrigin={{ vertical: "top", horizontal: "center" }}
                    PaperProps={{ style: { marginTop: 4, minWidth: 160 } }}
                  >
                    <MenuItem
                      onClick={() => selectPaymentFilter("all")}
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                      }}
                    >
                      <ListItemText primary="All shifts" />
                      <div
                        style={{
                          width: 24,
                          display: "flex",
                          justifyContent: "flex-end",
                          alignItems: "center",
                        }}
                      >
                        {paymentFilter === "all" ? (
                          <CheckIcon fontSize="small" />
                        ) : null}
                      </div>
                    </MenuItem>
                    {canShowPaidUnpaidOptions && (
                      <>
                        <MenuItem
                          onClick={() => selectPaymentFilter("paid")}
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                          }}
                        >
                          <ListItemText primary="Paid" />
                          <div
                            style={{
                              width: 24,
                              display: "flex",
                              justifyContent: "flex-end",
                              alignItems: "center",
                            }}
                          >
                            {paymentFilter === "paid" ? (
                              <CheckIcon fontSize="small" />
                            ) : null}
                          </div>
                        </MenuItem>
                        <MenuItem
                          onClick={() => selectPaymentFilter("unpaid")}
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                          }}
                        >
                          <ListItemText primary="Unpaid" />
                          <div
                            style={{
                              width: 24,
                              display: "flex",
                              justifyContent: "flex-end",
                              alignItems: "center",
                            }}
                          >
                            {paymentFilter === "unpaid" ? (
                              <CheckIcon fontSize="small" />
                            ) : null}
                          </div>
                        </MenuItem>
                      </>
                    )}
                    <MenuItem
                      onClick={() => selectPaymentFilter("rate-shift")}
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                      }}
                    >
                      <ListItemText primary="Rate Shift" />
                      <div
                        style={{
                          width: 24,
                          display: "flex",
                          justifyContent: "flex-end",
                          alignItems: "center",
                        }}
                      >
                        {paymentFilter === "rate-shift" ? (
                          <CheckIcon fontSize="small" />
                        ) : null}
                      </div>
                    </MenuItem>
                  </Menu>
                </>
              )}

              {isOwnerLike && (
                <IconButton
                  style={{ color: primaryColor }}
                  onClick={() => setOpenTuneSetting((prevOpen) => !prevOpen)}
                  ref={anchorTuneRef}
                >
                  <TuneIcon />
                </IconButton>
              )}
            </>
          }
        />
      </>
    );
  };
  const renderTuneSettingContent = () => {
    const pharmacyName = AuthService.getOwnerAccountInfo().pharmacyName;
    return (
      <>
        <Paper style={{ margin: Spacing.medium }}>
          {isOwnerLike &&
            (<RBCardView
              style={{
                display: "flex",
                flexDirection: "row",
                alignItems: "center",
                padding: Spacing.small,
              }}
              clickable={true}
              onClick={async () => {
                setOpenTuneSetting(false);

                setShowAllShifts((pre) => !pre);
              }}
            >
              <SwapHorizIcon fontSize={"large"} />
              <div style={{ paddingLeft: Spacing.larger }}>
                <Typography>
                  {showAllShifts ? "View limited shifts" : "View all shifts"}
                </Typography>
                <Typography variant={"caption"}>
                  {showAllShifts
                    ? `Select here to view: ${pharmacyName}`
                    : "Select here to view: Shifts for all"}
                </Typography>
              </div>
            </RBCardView>
            )}
        </Paper>
      </>
    );
  };
  const renderViews = () => {
    const anchorStyles = {
      cursor: 'pointer',
      // filter:`brightness(0) invert(1) saturate(100%) hue-rotate(${secondaryColor}deg)`,

    }

    return (
      <div style={{ flex: 1, textAlign: 'center' }}>
        <a
          style={anchorStyles}
          onClick={() => {
            setViewOption('List');
            setOpenTuneSetting(false);
            // setShowAllShifts(() => true)
          }}
        >
          <FormatListBulletted
            style={{
              width: 35,
              height: 35,
              marginTop: 10,
              marginRight: 20,
              color: viewOption === 'List' ?
                secondaryColor :
                'grey'
            }}
          />
        </a>

      </div>
    )
  }
  const renderTuneSetting = () => {
    // const pharmacyName = AuthService.getOwnerAccountInfo().pharmacyName;
    const allOfficeText = industryMode === IndustryModeEnum.Dentistry ?
      'Dental Practices' :
      industryMode === IndustryModeEnum.Pharmaceutical ?
        'Pharmacies' :
        'Companies';
    return (
      <RBModal
        open={openTuneSetting}
        backDropEnabled={true}
        style={{ minHeight: 0, height: isOwnerLike ? 300 : 200 }}
        onClose={() => setOpenTuneSetting((prevOpen) => !prevOpen)}
        modalTitle={isOwnerLike &&
          showAllShifts
          ? 'Current display: All Locations'
          : `Current display: ${localStorage.getItem("pharmacyName")}`
        }
        children={renderTuneSettingContent()}
      />
    );
  };

  // Paid/Unpaid filtering is handled by the backend via `shiftPaid` query param.
  // Rate Shift filtering is applied on frontend from fetched shifts.
  const visibleShifts =
    paymentFilter === "rate-shift"
      ? shifts.filter((shift) => {
          const canRateShift = isShiftRatingWindowOpen(shift);
          const ratingValue = getShiftRatingValue(
            shift,
            industryMode as any,
            roleName
          );
          const hasRating =
            typeof ratingValue === "number" && Number.isFinite(ratingValue);

          return canRateShift && !hasRating;
        })
      : shifts;

  return (
    <>
      <ShiftPaymentModal
        open={paymentModalVisible}
        onClose={closePaymentModal}
        shift={paymentShift}
        existingPayment={paymentShift?.paymentData}
        currentUser={account}
        primaryColor={primaryColor}
        secondaryColor={secondaryColor}
        onCreate={handleCreatePayment}
        onUpdate={handleUpdatePayment}
      />

      <RBAlert
        show={isAlertShowing}
        alertTitle={alertInfo.title}
        alertMessage={alertInfo.message}
        buttons={alertInfo.buttons}
      />

      {isPageLoading ? (
        <LoadingIndicator />
      ) : (
        <div style={{ paddingTop: Spacing.large }}>
          {renderAppBar()}
          {renderTuneSetting()}
          {((roleName === roleNameEnum.pharmacist && (industryMode === IndustryModeEnum.Dentistry || industryMode === IndustryModeEnum.Labour)) ||
            (roleName === roleNameEnum.pharmacist && industryMode === IndustryModeEnum.Pharmaceutical) ||
            (isOwnerLike && industryMode === IndustryModeEnum.Pharmaceutical)) &&
            <RBCardView
              key={"payrollHeader"}
              marginHorizontal={Spacing.large}
              marginVertical={Spacing.medium}
              paddingHorizontal={Spacing.large}
              paddingVertical={Spacing.medium}
            >

              {renderPayrollHeader()}
            </RBCardView>
          }
          {visibleShifts.map((shift) => (
            // <RBCardView
            //   key={shift.id}
            //   marginHorizontal={Spacing.large}
            //   marginVertical={Spacing.medium}
            //   paddingHorizontal={Spacing.large}
            //   paddingVertical={Spacing.medium}
            //   clickable={true}
            //   onClick={() =>
            //     history.push(`${RoutePathConstant.ShiftDetail}${shift.id}`)
            //   }
            // >
            renderPayrollItem(shift)
            // </RBCardView>
          ))}
          {visibleShifts.length == 0 &&
            <RBCardView
              key={"payrollHeader"}
              marginHorizontal={Spacing.large}
              marginVertical={Spacing.medium}
              paddingHorizontal={Spacing.large}
              paddingVertical={Spacing.medium}
            >
              <div>
                <div style={{ textAlign: "center" }}>
                  <Typography
                    style={{ fontWeight: "bold", fontSize: Font.largest, }}
                  >
                    No items found.
                  </Typography>
                </div>

              </div>
            </RBCardView>}
        </div>
      )}
    </>
  );
};
